import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import general from './store/general';
import user from './store/user';
import features from './store/features';

// Create a new store
const store = new Vuex.Store({
  modules: [general, user, features],
});

export default store;
